import { Icon } from '../Icon';
import { Input, InputProps } from './input';

export type InputSearchProps = Omit<InputProps, 'leftSection'>;

export const InputSearch = (props: InputSearchProps) => (
  <Input leftSection={<Icon icon="search" size="16px" variant="light-gray" />} {...props} />
);
